import { Link } from "react-router-dom"
import styled from "styled-components"

export const OnboardingWrapper = styled.div`
  font-size: 16px;
  line-height: 1.5;
  height: 100%;

  --header-height: 44px;
  background: var(--color-app-dark-linear-background);
  color: var(--color-white);
`

export const OnboardingContent = styled.div`
  padding-top: 12px;
  margin-bottom: auto;
  height: calc(100% - var(--header-height) - var(--app-cta-height));
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  padding: 0 var(--app-horizontal-padding);
`

export const CTABox = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
  margin-top: auto;
  padding: 12px 0px 16px 0px;

  & > * {
    width: 100%;
  }
`

export const ToPersonalLink = styled(Link)`
  color: var(--color-dark);
  display: flex;
  align-items: center;
  text-decoration: none;
`
